import React, { useState, useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { login } from "@reducers/authSlice";
import appConfig from "@config/app.config.json";
import { AxiosFetch } from "@hooks/axiosFetch";

import { Div, Button } from "@components/Generics.react";
import AuthLayout from "@layouts/AuthLayout.react";

export default function Register(props) {
    const [username, setUsername] = useState("");
    const [validUsername, setValidUsername] = useState(false);
    const [org, setOrg] = useState("");
    const [email, setEmail] = useState("");
    const [validEmail, setValidEmail] = useState(false);
    const [password, setPassword] = useState("");
    // const [validPassword, setValidPassword] = useState(false);

    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation("common");

    useEffect(() => {
        (async () => {
            if (username.length > 3) {
                const response = await AxiosFetch(
                    appConfig.endpoints.checkUsername.replace(
                        ":username",
                        username
                    )
                );
                const data = await response.json();
                data.available
                    ? setValidUsername(true)
                    : setValidUsername(false);
            }
        })();
        return () => {
            // this now gets called when the component unmounts
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username]);
    useEffect(() => {
        // eslint-disable-next-line
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
            ? setValidEmail(true)
            : setValidEmail(false);
    }, [email]);

    const tryRegister = async () => {
        let formData = new FormData();
        formData.append("username", username);
        formData.append("password", password);

        try {
            const response = await AxiosFetch("formSignIn", {
                method: "POST",
                body: formData,
            });
            const data = await response.json();
            setError(null);
            dispatch(
                login({
                    success: true,
                    user: data,
                })
            );
            navigate("/");
        } catch (error) {
            setError(error.response.message);
            dispatch(
                login({
                    success: false,
                    user: null,
                })
            );
        }
    };

    const checkStyle = { float: "right", margin: "-30px 10px 0 0" };

    // ========================= Render Function =================================
    return (
        <AuthLayout title={`Register on ${t("appName")}`}>
            <Div fluid white fullHt>
                <Div massive altText fluid center-align gutter>
                    SIGN UP
                </Div>
                {error && (
                    <Div padded fluid danger gutter>
                        {error}
                    </Div>
                )}
                <Div fluid gutter>
                    <Input
                        label="Select Team Name"
                        placeholder="Give your team a unique name"
                        value={username}
                        onSubmit={(value) => setUsername(value)}
                    />
                    {!validUsername && username?.length > 0 && (
                        <Div relaxed danger fluid>
                            <i className="fa fa-times" /> &nbsp; This team name
                            is already in use
                        </Div>
                    )}
                    {validUsername && (
                        <Div txtColor="success" style={checkStyle}>
                            <i className="fa fa-check-circle" />
                        </Div>
                    )}
                </Div>
                <Div fluid gutter>
                    <Input
                        label="Organization Name"
                        placeholder="Where do you work?"
                        value={org}
                        onSubmit={(value) => setOrg(value)}
                    />
                </Div>
                <Div fluid gutter>
                    <Input
                        label="Email"
                        type="email"
                        placeholder="Where can we contact you?"
                        value={email}
                        onSubmit={(value) => setEmail(value)}
                    />
                    {!validEmail && email?.length > 0 && (
                        <Div relaxed danger fluid>
                            <i className="fa fa-times" /> &nbsp; Malformed email
                            address.
                        </Div>
                    )}
                    {validEmail && (
                        <Div txtColor="success" style={checkStyle}>
                            <i className="fa fa-check-circle" />
                        </Div>
                    )}
                </Div>
                <Div fluid gutter>
                    <Input
                        label="Password"
                        type="password"
                        placeholder="Input Password"
                        onSubmit={(value) => setPassword(value)}
                    />
                </Div>
                <Div fluid gutter>
                    <Button
                        fluid
                        big
                        content="SUBMIT"
                        onClick={tryRegister}
                        isDisabled={username.length > 3 && validUsername}
                    />
                </Div>
            </Div>
        </AuthLayout>
    );
}
